import React from 'react';
import './RouteLoadingSpinner.css';

const RouteLoadingSpinner = () => (
  <div className="route-loading">
    <div className="route-loading-spinner" />
  </div>
);

export default RouteLoadingSpinner;
